import type { OffboardingStatus } from "../schemas/offboarding-request.schema.ts";
import type { SelectOption } from "../../../ui/index.ts";

/** UI labels aligned with the offboarding progress tracker steps. */
export const OFFBOARDING_STATUS_LABELS: Partial<Record<OffboardingStatus, string>> = {
    RESIGNATION_SUBMITTED: "Under Review",
    UNDER_REVIEW: "Under Review",
    LWD_CONFIRMED: "Last Working Day Confirmed",
    CLEARANCE_IN_PROGRESS: "Clearances In Progress",
    EXIT_FORM_PENDING: "Exit Interview Pending",
    HR_CLEARANCE_PENDING: "HR Clearance",
    EXIT_COMPLETED: "Exit Completed",
    WITHDRAWN: "Withdrawn",
    REJECTED: "Rejected",
    RESIGNATION_PENDING: "Resignation Pending",
};

export function formatOffboardingStatusLabel(status: string | undefined): string {
    if (status == null || status === "") return "—";

    const mapped = OFFBOARDING_STATUS_LABELS[status as OffboardingStatus];
    if (mapped != null) return mapped;

    return status
        .split("_")
        .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
        .join(" ");
}

export const OFFBOARDING_LIST_STATUS_FILTER_OPTIONS: SelectOption[] = [
    { value: "", label: "All" },
    { value: "RESIGNATION_SUBMITTED", label: OFFBOARDING_STATUS_LABELS.RESIGNATION_SUBMITTED! },
    { value: "LWD_CONFIRMED", label: OFFBOARDING_STATUS_LABELS.LWD_CONFIRMED! },
    {
        value: "CLEARANCE_IN_PROGRESS",
        label: OFFBOARDING_STATUS_LABELS.CLEARANCE_IN_PROGRESS!,
    },
    { value: "EXIT_FORM_PENDING", label: OFFBOARDING_STATUS_LABELS.EXIT_FORM_PENDING! },
    { value: "HR_CLEARANCE_PENDING", label: OFFBOARDING_STATUS_LABELS.HR_CLEARANCE_PENDING! },
    { value: "EXIT_COMPLETED", label: OFFBOARDING_STATUS_LABELS.EXIT_COMPLETED! },
    { value: "WITHDRAWN", label: OFFBOARDING_STATUS_LABELS.WITHDRAWN! },
    { value: "REJECTED", label: OFFBOARDING_STATUS_LABELS.REJECTED! },
];

/** IT / Payroll / Admin / RM approvers — clearance-stage statuses only. */
export const CLEARANCE_DEPT_LIST_STATUS_FILTER_OPTIONS: SelectOption[] = [
    { value: "LWD_CONFIRMED", label: OFFBOARDING_STATUS_LABELS.LWD_CONFIRMED! },
    {
        value: "CLEARANCE_IN_PROGRESS",
        label: OFFBOARDING_STATUS_LABELS.CLEARANCE_IN_PROGRESS!,
    },
];
